import { InvoiceBillingStage } from '../../enums/invoiceBillingStage'
import { CancelDepositInvoiceEligibility } from '../../types/invoiceDeposit/cancelDepositInvoiceEligibility'
import type { Invoice } from '../../types/invoices/invoice'

type CancelDepositInvoiceEligibilityData = Pick<Invoice, 'billingStage' | 'relatedInvoices'>

export const getCancelDepositInvoiceEligibility = (
  invoice?: CancelDepositInvoiceEligibilityData,
): CancelDepositInvoiceEligibility => {
  const relatedFinalInvoice =
    invoice?.billingStage === InvoiceBillingStage.Deposit
      ? invoice.relatedInvoices?.find((relatedInvoice) => relatedInvoice.billingStage === InvoiceBillingStage.Final)
      : undefined

  if (relatedFinalInvoice === undefined) {
    return { isCancelBlockedByFinalInvoice: false }
  }

  return {
    isCancelBlockedByFinalInvoice: true,
    relatedFinalInvoice,
  }
}
